export const iconStyle = {/* fontSize: "2.2rem",*/ color: "rgb(30 67 128)" }
export const actionButtonSize = { width: "2rem", height: "2rem" }
